import { AuthorizationContext } from '../authorizationcontext';
import { AuthorizationHandler } from '../authorizationhandler';
import { DenyAnonymousRequirement } from '../requirements/denyanonymous.requirement';

export class DenyAnonymousHandler extends AuthorizationHandler<DenyAnonymousRequirement> {
  constructor() {
    super(`DenyAnonymousRequirement`);
  }

  onHandle(context: AuthorizationContext, requirement: DenyAnonymousRequirement): void {
    if (context.principal == null) {
      context.fail(requirement);
    } else {
      context.succeed(requirement);
    }
  }
}
